import { Container } from './styles';

import loadingImg from '../../assets/loading.svg';

const Loading: React.FC = () => {
  return (
    <Container>
      <img src={loadingImg} alt="Carregando" />
      <h3>Confirmando Compra</h3>
    </Container>
  );
};

export default Loading;
